<template>
    <div class="fadein">
        <div class="h30"></div>
        <Goback></Goback>

        <div class="center1200">
            <div class="user" >
                <transition name="el-zoom-in-center">
                <div class="user-left" v-if="userinfo.user_id">

                    <div class="bg-white shadow " style="text-align: center;" >
                        <div class="h30"></div>
                        <span class="user-box">
                            
                            <router-link to="/account" v-if="uid==token">
                                <img :src="userinfo.user_pic" alt="" class="user-head">
                            </router-link>
                            <a href="javascript:;" v-else>
                                <img :src="userinfo.user_pic" alt="" class="user-head">
                            </a>

                            
                            <div class="username" v-if="userinfo.nickname">
                                <!-- 用户等级 -->
                                <img style="vertical-align: middle;" src="/static/img/lv/LV0.png" alt="" v-if="userinfo.level==0"><img style="vertical-align: middle;" src="/static/img/lv/LV1.png" alt="" v-if="userinfo.level==1"><img style="vertical-align: middle;" src="/static/img/lv/LV2.png" alt="" v-if="userinfo.level==2"><img style="vertical-align: middle;" src="/static/img/lv/LV3.png" alt="" v-if="userinfo.level==3"><img style="vertical-align: middle;" src="/static/img/lv/LV4.png" alt="" v-if="userinfo.level==4"><img style="vertical-align: middle;" src="/static/img/lv/LV5.png" alt="" v-if="userinfo.level==5">{{userinfo.nickname}}</div>
                            <!-- <div class="username" v-else-if="userinfo.username">{{userinfo.username}}</div> -->
                            <div class="username" v-else>
                                <img style="vertical-align: middle;" src="/static/img/lv/LV0.png" alt="" v-if="userinfo.level==0"><img style="vertical-align: middle;" src="/static/img/lv/LV1.png" alt="" v-if="userinfo.level==1"><img style="vertical-align: middle;" src="/static/img/lv/LV2.png" alt="" v-if="userinfo.level==2"><img style="vertical-align: middle;" src="/static/img/lv/LV3.png" alt="" v-if="userinfo.level==3"><img style="vertical-align: middle;" src="/static/img/lv/LV4.png" alt="" v-if="userinfo.level==4"><img style="vertical-align: middle;" src="/static/img/lv/LV5.png" alt="" v-if="userinfo.level==5">{{userinfo.mobile}}
                            </div>
                        </span>
                        <div class="userdesn" v-if="userinfo.signature">{{userinfo.signature}}</div>
                        <div class="userdesn" v-else>系统原装签名，献给每一位小可爱</div>
                        <div class="h30"></div>
                        <div class="usercount">
                            <div class="countbox">获赞<br><a href="javascript:;">{{userinfo.zans_count}}</a></div>
                            <div class="countbox">关注<br><a href="javascript:;" @click="showFocus">{{userinfo.focus_count}}</a></div>
                            <div class="countbox">粉丝<br><a href="javascript:;" @click="showFans">{{userinfo.fans_count}}</a></div>
                        </div>
                        <div class="h30"></div>
                        <div v-if="token!=uid">
                            <el-button type="info" round style="width:250px;font-size:18px;height:34px;line-height: 0;" @click="$router.push('/login').catch(err => {err});
                                " v-if="token==null">请先登录</el-button>
                            <el-button type="primary" round :class="follow_class" @click="follow()" v-else-if="follow_class=='follow-plain'">已关注</el-button>
                            <el-button type="primary" round :class="follow_class" @click="follow()" v-else>关注</el-button>
                            <div class="h30"></div>
                        </div>
                    </div>
                
                    <div class="h20"></div>

                    <transition name="el-zoom-in-center">
                    <div :class="focus_class" v-if="focus_class==''">
                    <div class="bg-white shadow" v-if="userinfo.user_id" >
                        <div class="h20"></div>
                        <div class="center-title"><img class="title-pic" src="/static/img/title-left.png" alt=""> ta关注的人 <img class="title-pic" src="/static/img/title-right.png" alt=""></div>
                        <div class="padding20">
                            <div style="text-align: center;color:#999;" v-if="focus_total==0" >暂无关注</div>
                            <div v-else>
                                <div v-for="v,k in focus_user_show" class="user-focus">
                                    <div v-if="v.focus_user_info.extras!=null">
                                        <img class="user-focus-pic" @click="goUserinfo(v.focus_user_info.id)" :src="v.focus_user_info.extras.user_pic" alt="" v-if="v.focus_user_info.extras.user_pic!='http://'+ $API_URL">
                                        <img class="user-focus-pic" @click="goUserinfo(v.focus_user_info.id)" src="/static/img/default_userpic.png" alt="" v-else>
                                        <span class="user-focus-username" @click="goUserinfo(v.focus_user_info.id)" v-if="v.focus_user_info.extras.nickname!=null">{{v.focus_user_info.extras.nickname}}</span>
                                        <span class="user-focus-username" @click="goUserinfo(v.focus_user_info.id)" v-else>{{v.focus_user_info.mobile}}</span>
                                    </div>
                                    <div v-else @click="goUserinfo(v.focus_user_info.id)">
                                        <img class="user-focus-pic" @click="goUserinfo(v.focus_user_info.id)" src="/static/img/default_userpic.png" alt="">
                                        <span class="user-focus-username" @click="goUserinfo(v.focus_user_info.id)">{{v.focus_user_info.mobile}}</span>
                                    </div>
                                </div>
                                <div style="text-align: center;">
                                    <el-pagination
                                    :pager-count="5"
                                    layout="prev, pager, next"
                                    :total="focus_total"
                                    :page-size="user_pagesize"
                                    :current-page="focus_page"
                                    @current-change="focusCurrentChange"
                                    hide-on-single-page>
                                    </el-pagination>
                                </div>
                            </div>

                        </div>
                        
                    </div>
                    </div>
                    </transition>
                    <transition name="el-zoom-in-center">
                    <div :class="fans_class" v-if="fans_class==''">
                    <div class="bg-white shadow" v-if="userinfo.user_id">
                        <div class="h20"></div>
                        <div class="center-title"><img class="title-pic" src="/static/img/title-left.png" alt=""> ta的粉丝 <img class="title-pic" src="/static/img/title-right.png" alt=""></div>
                        <div class="padding20" >
                            <div style="text-align: center;color:#999;" v-if="fans_total==0" >暂无粉丝</div>

                            <div class="fans-show" v-else>
                                <div v-for="v,k in fans_user_show" class="user-focus">
                                    <div v-if="v.fan_user_info.extras!=null">
                                        <img class="user-focus-pic" @click="goUserinfo(v.fan_user_info.id)" :src="v.fan_user_info.extras.user_pic" alt="" v-if="v.fan_user_info.extras.user_pic!='http://'+ $API_URL">
                                        <img class="user-focus-pic" @click="goUserinfo(v.fan_user_info.id)" src="/static/img/default_userpic.png" alt="" v-else>
                                        <span class="user-focus-username" @click="goUserinfo(v.fan_user_info.id)" v-if="v.fan_user_info.extras.nickname!=null">{{v.fan_user_info.extras.nickname}}</span>
                                        <span class="user-focus-username" @click="goUserinfo(v.fan_user_info.id)" v-else>{{v.fan_user_info.mobile}}</span>
                                    </div>
                                    <div v-else @click="goUserinfo(v.fan_user_info.id)">
                                        <img class="user-focus-pic" @click="goUserinfo(v.fan_user_info.id)" src="/static/img/default_userpic.png" alt="">
                                        <span class="user-focus-username" @click="goUserinfo(v.fan_user_info.id)">{{v.fan_user_info.mobile}}</span>
                                    </div>
                                </div>
                            </div>
                            <div style="text-align: center;">
                                <el-pagination
                                :pager-count="5"
                                layout="prev, pager, next"
                                :total="fans_total"
                                :page-size="user_pagesize"
                                :current-page="fans_page"
                                @current-change="fansCurrentChange"
                                hide-on-single-page>
                                </el-pagination>
                            </div>
                        </div>
                        
                    </div>
                    </div>
                    </transition>
                    <div class="h20"></div>
                    <!-- 发布的论坛 Start -->
                    <transition name="el-zoom-in-center">
                        <div v-if="publish_forum">
                        <div class="hot-forum shadow" v-if="userinfo.user_id">
                            <div class="center-title"><img class="title-pic" src="/static/img/title-left.png" alt=""> 发布的文章 <img class="title-pic" src="/static/img/title-right.png" alt=""></div>
                            <div class="padding20" style="text-align: center;color:#999;" v-if="publish_forum_total==0" >暂无文章</div>
                            <div v-else>
                                <div class="h20"></div>
                                <ul>
                                    <li v-for="v,k in publish_forum_show">
                                      <a href="javascript:;" @click="goForumDetail(v.id)">{{v.title}}</a>
                                      <div class="gray"><i class="el-icon-view"></i> {{v.reviews_count}}</div>
                                    </li>
                                  </ul>
                            <div style="text-align: center;">
                                <el-pagination
                                :pager-count="5"
                                layout="prev, pager, next"
                                :total="publish_forum_total"
                                :page-size="publish_forum_pagesize"
                                :current-page="publish_forum_page"
                                @current-change="publishforumCurrentChange"
                                hide-on-single-page>
                                </el-pagination>
                            </div>
                            </div>

                            
                        </div>
                        </div>
                    </transition>
                    <!-- 发布的论坛 End -->
                    <div class="h20"></div>
                    <!-- 收藏的文章 Start -->
                    <transition name="el-zoom-in-center">
                        <div v-if="publish_forum">
                        <div class="hot-forum shadow" v-if="userinfo.user_id">
                            <div class="center-title"><img class="title-pic" src="/static/img/title-left.png" alt=""> 收藏的文章 <img class="title-pic" src="/static/img/title-right.png" alt=""></div>
                            <div class="padding20" style="text-align: center;color:#999;" v-if="fav_forum_total==0" >暂无文章</div>
                            <div v-else>
                                <div class="h20"></div>
                                <ul>
                                    <li v-for="v,k in fav_forum_show">
                                      <a href="javascript:;" @click="goForumDetail(v.article_id)">{{v.articles.title}}</a>
                                      <div class="gray"><i class="el-icon-view"></i> {{v.articles.reviews_count}}</div>
                                    </li>
                                  </ul>
                            <div style="text-align: center;">
                                <el-pagination
                                :pager-count="5"
                                layout="prev, pager, next"
                                :total="fav_forum_total"
                                :page-size="fav_forum_pagesize"
                                :current-page="fav_forum_page"
                                @current-change="favForumCurrentChange"
                                hide-on-single-page>
                                </el-pagination>
                            </div>
                            </div>

                            
                        </div>
                        </div>
                    </transition>
                    <!-- 收藏的文章 End -->
                    <div class="h20"></div>
                    <!-- <div class="bg-white shadow">参与的论坛</div> -->
                </div>
                </transition>
                <transition name="el-zoom-in-center">
                <div class="user-right " v-if="userinfo.user_id">
                    <div class="bg-white shadow">
                        <div class="h20"></div>
                        <div class="center-title"><img class="title-pic" src="/static/img/title-left.png" alt=""> 喜欢的电影 <img class="title-pic" src="/static/img/title-right.png" alt=""></div>
                        <div class="padding20">
                            <div style="text-align: center;color:#999;" v-if="user_fav_movies.length==0">暂无电影</div>
                            <div class="movieboxes" v-if="user_fav_movies.length>0">
                                <div class="moviebox" v-for="v in user_fav_movies_show">
                                  <a href="javascript:;" @click="goMovieDetail(v.movies.id)">
                                    <img :src="v.movies.cover" alt="" class="moviepic" />
                                  </a>
                                  <a href="" @click="goMovieDetail(v.movies.id)">{{v.movies.title}}</a>
                                  <p>
                                    <span v-for="val in v.movies.withtypes">
                                      {{val.type}}
                                    </span>
                                  </p>
                                </div>
                                <div style="width:172px;" v-for="n in flex_movies_align"></div>
                            </div>
                            <el-pagination
                                style="text-align:center"
                                :pager-count="5"
                                layout="prev, pager, next"
                                :total="user_fav_movies_total"
                                :page-size="user_fav_movies_pagesize"
                                :current-page="user_fav_movies_page"
                                @current-change="favMovieCurrentChange"
                                hide-on-single-page>
                            </el-pagination>
                        </div>
                    </div>
                    <div class="h20"></div>
                    <!-- 发布的电影评论 Start -->
                    <div class="bg-white shadow" >
                        <div class="h20"></div>
                        <div class="center-title"><img class="title-pic" src="/static/img/title-left.png" alt=""> 发布的电影评论 <img class="title-pic" src="/static/img/title-right.png" alt=""></div>
                        <div class="padding20" v-if="comments.length>0">
                            <div v-for="v,k in comments_show" >
                                <div class="comment-movie">
                                    电影：<a href="javascript:;" @click="goMoiveDetail(v.movie_id)">{{v.movie_title}}</a>
                                </div>
                                <div class="comment-content">
                                    {{v.content}}
                                </div>
                                <div class="comment-time">
                                    <a href="javascript:;" v-if="uid==token" @click="deleteComment(v.id)">删除评论</a> 发布日期：{{v.created_at}}
                                </div>
                                <el-divider></el-divider>
                            </div>
                            <div style="text-align: center;">
                                <el-pagination
                                :pager-count="7"
                                layout="prev, pager, next"
                                :total="comment_length"
                                :page-size="pagesize"
                                @current-change="currentChange"
                                hide-on-single-page>
                                </el-pagination>
                                <!-- {{comment_length}} -->
                            </div>
                        </div>
                        <div class="padding20" style="text-align: center;color:#999;" v-else>暂无评论</div>
                    </div>
                    <!-- 发布的电影评论 End -->
                    <div class="h20"></div>
                    <!-- 参与的论坛 Start -->
                    <div class="bg-white shadow" >
                        <div class="h20"></div>
                        <div class="center-title"><img class="title-pic" src="/static/img/title-left.png" alt=""> 参与的论坛 <img class="title-pic" src="/static/img/title-right.png" alt=""></div>
                        <div class="padding20" v-if="comment_forum_total>0">
                            <div v-for="v,k in comment_forum_show" >
                                <div class="comment-movie">
                                    文章标题：<a href="javascript:;" @click="goForumDetail(v.article_id)">{{v.article_title}}</a>
                                </div>
                                <div class="comment-content">
                                    {{v.content}}
                                </div>
                                <div class="comment-time">
                                    <a href="javascript:;" v-if="uid==token" @click="deleteForumComment(v.id)">删除评论</a> 发布日期：{{v.created_at}}
                                </div>
                                <el-divider></el-divider>
                            </div>
                            <div style="text-align: center;">
                                <el-pagination
                                :pager-count="7"
                                layout="prev, pager, next"
                                :total="comment_forum_total"
                                :page-size="comment_forum_pagesize"
                                :current-page="comment_forum_page"
                                @current-change="commentForumCurrentChange"
                                hide-on-single-page>
                                </el-pagination>
                                <!-- {{comment_length}} -->
                            </div>
                        </div>
                        <div class="padding20" style="text-align: center;color:#999;" v-else>暂无评论</div>
                    </div>
                    <!-- 参与的论坛 End -->
                </div>
            </transition>
            </div>
        </div>

        <div class="h30"></div>
    </div>
</template>
<script>
    import Goback from '@/components/components/goback'
    export default{
        components:{
            Goback,

        },
        data(){
            return {
                loading:0,
                userinfo : {
                    nickname:'',
                    signature:'',
                    // uid:0,
                },
                //该页面的用户信息所对应的id
                uid:0,
                //当前登录用户的id
                token:0,
                //当前页面的用户评论
                comments:[],
                //评论数量
                comment_length:0,

                comments_show:[],

                //每页显示的评论数量
                pagesize:5,

                //用户喜欢的电影
                flex_movies_align:0,
                
                user_fav_movies:[],
                user_fav_movies_total:0,
                user_fav_movies_show:[],
                user_fav_movies_page:1,
                user_fav_movies_pagesize:8,


                //关注与粉丝的分页每页的条数
                user_pagesize:10,
                //ta关注的人
                focus_user:[],
                focus_total:0,
                focus_page:1,
                focus_user_show:[],
                //ta的粉丝
                fans_user:[],
                fans_user_show:[],
                fans_total:0,
                fans_page:1,

                focus_class:"",
                fans_class:"focus-hidden",

                follow_class:"follow-plain",

                //用户发布的文章
                publish_forum:[],
                publish_forum_show:[],
                publish_forum_total:0,

                publish_forum_pagesize:5,
                publish_forum_page:1,

                //用户参与的论坛
                comment_forum:[],
                comment_forum_show:[],
                comment_forum_total:0,

                comment_forum_pagesize:5,
                comment_forum_page:1,

                //用户收藏的文章
                fav_forum:[],
                fav_forum_show:[],
                fav_forum_total:0,

                fav_forum_pagesize:5,
                fav_forum_page:1,

                

            }
        },
        watch:{
            $route(newVal,oldVal){
                if(newVal.name=="user"){
                    this.$parent.activeIndex = '0'
                    this.loading = 0;

                    this.publish_forum = []
                    // 
                    this.token = localStorage.getItem('token')
                    this.userinfo = {}
                    if(newVal.params == oldVal.params){
                        return false;
                        
                    }else{
                        this.publish_forum = []
                        this.getUserinfo(this.$route.params.uid);
                        this.getUserFav();
                        this.getPublishForum();
                        this.getCommentForum();
                        this.getFavForum();
                        this.openFullScreen();
                    }
                }
                // 
            }
        },
        mounted(){
            this.$parent.activeIndex = '0'
            this.publish_forum = []
            // this.uid = this.$route.params.uid
            this.token = localStorage.getItem('token')
            this.getUserinfo(this.$route.params.uid);
            this.getUserFav()
            this.getPublishForum();
            this.getCommentForum();
            this.getFavForum();
        },
        methods:{
            //根据用户id获取用户信息
            getUserinfo(uid){
                this.uid = uid
                $.ajax({
                    url:'//'+ this.$API_URL +'/api/v1/user_info/'+uid,
                    type:'get',
                    timeout:3000,
                    success:(ret)=>{
                        this.userinfo=ret.data
                        if(ret.data.username == ''){
                            this.userinfo.username = ret.data.mobile
                        }
                        if(ret.data.user_pic == "http://"+ this.$API_URL){
                            this.userinfo.user_pic = '/static/img/default_userpic.png'
                        }
                        // 
                        this.getFocusUser()
                        this.getFansUser()
                        this.loading = 1
                        this.openFullScreen()
                    }
                })
                this.getUserComment();
                this.judgeFocus()
            },
            //分页elementui
            currentChange(val){
                // 
                this.comments_show = this.comments.slice((val-1)*this.pagesize,(val-1)*this.pagesize+this.pagesize)
            },
            //获取用户发布的评论
            getUserComment(){
                //获取用户发布的评论
                $.ajax({
                    url:'//'+ this.$API_URL +'/api/v1/comments/self_comments',
                    type:'post',
                    data:{user_id:this.$route.params.uid},
                    success:(ret)=>{
                        this.comments = ret.data

                        this.comment_length = ret.data.length

                        this.comments_show = this.comments.slice(0,this.pagesize)
                    }
                })
            },
            //跳转到电影详情
            goMovieDetail(id){
                // 
                this.$router.push('/movie/'+id);
            },
            //获取用户对应喜欢的电影
            getUserFav(){
                $.ajax({
                    url:"//" + this.$API_URL + "/api/v1/movies/all_likes",
                    type:"post",
                    data:{user_id:this.uid},
                    success:(ret)=>{
                        // 
                        this.user_fav_movies = ret.data;
                        // 
                        this.flex_movies_align = 4 - (this.user_fav_movies.length % 4)

                        this.user_fav_movies_total = ret.data.length
                        this.user_fav_movies_show = this.user_fav_movies.slice(0,this.user_fav_movies_pagesize);
                    }
                })
            },

            //喜欢的电影分页
            favMovieCurrentChange(val){
                this.user_fav_movies_show = this.user_fav_movies.slice((val-1)*this.user_fav_movies_pagesize,(val-1)*this.user_fav_movies_pagesize+this.user_fav_movies_pagesize)
            },

            //点击电影名称跳转
            goMoiveDetail(mid){
                this.$router.push('/movie/'+mid);
            },

            //删除自己的评论
            deleteComment(id){
                this.$confirm('此操作将删除该评论, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    $.ajax({
                        url:"//" + this.$API_URL + "/api/v1/comments/delete_self_comments/"+id,
                        type:"post",
                        data:{user_id:this.token},
                        success:(ret)=>{
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getUserComment();
                        }
                    })
                    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },

            //删除自己的文章评论
            deleteForumComment(id) {
                this.$confirm("此操作将删除该评论, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                    $.ajax({
                        url:
                        "//" + this.$API_URL + "/api/v1/articles/comments/delete_self_comments/"+id,
                        type: "post",
                        data: { user_id: localStorage.getItem("token") },
                        success: ret => {
                            this.$message({
                            type: "success",
                            message: "删除成功!"
                            });
                            this.getForumComment();
                        }
                    });
                    })
                    .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                    });
                },

            //获取ta关注的人
            getFocusUser(){
                $.ajax({
                    url:"//" + this.$API_URL + "/api/v1/users/focus_users/"+this.uid,
                    type:"get",
                    success:(ret)=>{
                        if(ret.code == 200){
                            // 
                            // 
                            this.focus_user = ret.data;
                            this.focus_total = ret.data.length;
                            this.focus_user_show = this.focus_user.slice(0,this.user_pagesize);
                            // 
                        }
                    }
                })
            },
            //获取ta的粉丝
            getFansUser(){
                
                $.ajax({
                    url:"//" + this.$API_URL + "/api/v1/users/fan_users/"+this.uid,
                    type:"get",
                    success:(ret)=>{
                        if(ret.code == 200){
                            // 
                            // 
                            this.fans_user = ret.data;
                            this.fans_total = ret.data.length;
                            this.fans_user_show = this.fans_user.slice(0,this.user_pagesize);
                            // 
                        }

                    }
                    
                })
            },
            
            //显示与隐藏关注的人与粉丝窗口（切换）
            showFocus(){
            
                this.fans_class = 'focus-hidden'
                this.focus_user_show = this.focus_user.slice(0,this.user_pagesize);
                setTimeout(()=>{
                this.focus_class = ''
                },250)
                // $('.focus-hidden').attr('class','focus-show')
                // $('.fans-show').attr('class','fans-hidden')
            },
            showFans(){
                // 
                this.focus_class = 'focus-hidden'
                setTimeout(()=>{
                this.fans_class = ''
                },250)
                this.fans_user_show = this.fans_user.slice(0,this.user_pagesize);
                // $('.focus-show').attr('class','focus-hidden')
                // $('.fans-hidden').attr('class','fans-show')
            },
            //点击用户名或头像跳转到用户信息页
            goUserinfo(uid){
                this.$router.push('/user/'+uid).catch(err => {err});
            },
            
            //获取用户发布的文章
            getPublishForum(){
                $.ajax({
                    url:"//" + this.$API_URL + "/api/v1/articles/self_articles",
                    type:"post",
                    data:{user_id:this.uid},
                    success:(ret)=>{
                        this.publish_forum = ret.data
                        this.publish_forum_total = ret.data.length;
                        this.publish_forum_show=this.publish_forum.slice(0,this.publish_forum_pagesize);

                    }
                })
            },
            //获取用户论坛评论的内容
            getCommentForum(){
                $.ajax({
                    url:'//'+ this.$API_URL +'/api/v1/articles/comments/self_comments',
                    type:"post",
                    data:{user_id:this.uid},
                    success:(ret)=>{
                        this.comment_forum = ret.data
                        this.comment_forum_total = ret.data.length;
                        this.comment_forum_show=this.comment_forum.slice(0,this.comment_forum_pagesize);
                    }
                })
            },
            //用户发布的文章分页
            publishforumCurrentChange(val){
	                this.publish_forum_page = val
	                this.publish_forum_show = this.publish_forum.slice((val-1)*this.publish_forum_pagesize,(val-1)*this.publish_forum_pagesize+this.publish_forum_pagesize)
            },
            //用户文章评论分页
            commentForumCurrentChange(val){
                this.comment_forum_page = val
                this.comment_forum_show = this.comment_forum.slice((val-1)*this.comment_forum_pagesize,(val-1)*this.comment_forum_pagesize+this.comment_forum_pagesize)
            },
            
            //获取用户收藏的文章
            getFavForum(){
                $.ajax({
                    url:"//" + this.$API_URL + "/api/v1/articles/all_favs",
                    type:"post",
                    data:{user_id:this.uid},
                    success:(ret)=>{
                        this.fav_forum = ret.data
                        this.fav_forum_total = ret.data.length
                        this.fav_forum_show = this.fav_forum.slice(0,this.fav_forum_pagesize);

                    }
                })
            },
            favForumCurrentChange(val){
                this.fav_forum_show = this.fav_forum.slice((val-1)*this.fav_forum_pagesize,(val-1)*this.fav_forum_pagesize+this.fav_forum_pagesize)
            },
            
            //进行关注
            follow(){
                $.ajax({
                    url:"//" + this.$API_URL + "/api/v1/users/focus",
                    type:"post",
                    data:{user_id:this.token,focus_user_id:this.uid},
                    success:(ret)=>{
                        this.$message({
                            showClose:true,
                            message:ret.msg,
                            type:"success"
                        })
                        this.getUserinfo(this.uid)
                        this.getFocusUser()
                        this.getFansUser()
                    }
                })
            },
            
            openFullScreen() {
                const loading = this.$loading({
                lock: true,
                text: "页面加载中（￣口￣）。。。",
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
                });
                // setTimeout(() => {
                if(this.loading==1){
                    loading.close();
                }
                // }, 2000);
            },

            //关注的人分页
            focusCurrentChange(val){
                // 
                this.focus_user_show = this.focus_user.slice((val-1)*this.user_pagesize,(val-1)*this.user_pagesize+this.user_pagesize)
            },
            fansCurrentChange(val){
                this.fans_user_show = this.fans_user.slice((val-1)*this.user_pagesize,(val-1)*this.user_pagesize+this.user_pagesize)
            },
            //判断用户是否关注
            judgeFocus(){
                if(this.token==null){
                    return false;
                }
                $.ajax({
                    url:"//" + this.$API_URL + "/api/v1/users/is_focus_user/"+this.token,
                    type:"post",
                    data:{user_id:this.uid},
                    success:(ret)=>{
                        
                        if(ret.msg=="已关注"){

                            this.follow_class = "follow-plain"
                        }else{
                            this.follow_class = "follow"
                        }
                    }
                })
            },
            //跳转到论坛详情
            goForumDetail(fid){
            this.$router.push('/forumdetail/'+fid).catch(err => {err});
            },
        }
    }
</script>
<style scoped>
    .user{
        display: flex;
        justify-content: space-between;
        /* box-shadow: 0px 5px 10px #000; */
    }
    .user-left{
        width:370px;
        /* padding:25px; */
    }
    .user-right{
        width:810px;
    }
    .user-head{
        width:128px;
        height:128px;
        border-radius: 50%;
    }
    .user-focus{
        padding-left:20px;
        margin-bottom:10px;
    }
    .user-focus-pic{
        width:50px;
        height:50px;
        border-radius: 50%;
        float:left;
        margin-right:15px;
        cursor: pointer;
    }
    .user-focus-username{
        display:inline-block;
        line-height:50px;
        max-width:200px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        cursor: pointer;
    }
    .focus-hidden{
        display: none;
    }
    .fans-hidden{
        display: none;
    }
    .username{
        font-size:20px;
        color:#3c3c3b;
        font-weight: 600;
        transition: 0.5s;
        margin-bottom:5px;
        width:250px;
        margin:0 auto;
    
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .user-box:hover .username{
        color:#ff7400;
        transition: 0.5s;
    
    }
    .userdesn{
        color:#999;
        width:270px;
        margin:0 auto;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .usercount{
        color:#3c3c3b;
        display: flex;
        justify-content:space-evenly;
    }
    .countbox{
        width:80px;
        line-height: 30px;
        font-size:14px;
        font-family: Arial, Helvetica, sans-serif;
        text-align: center;
    }
    .countbox a{
        
        font-size:24px;
        text-decoration: none;
        color:#3c3c3b;
    }
    .countbox a:hover{
        color:#ff7400;
    }
    .follow{
        /* background:#ff7400; */
        width:250px;
        margin:0 auto;
        height:34px;
        line-height: 0px;
        color:#fff;
        font-size:18px;
    }
    .follow-plain{
        background:#009999;
        border:1px solid #009999;
        width:250px;
        margin:0 auto;
        height:34px;
        line-height: 0px;
        color:#fff;
        font-size:18px;
    
    }
    .comment-movie{
        padding-left:10px;
        margin-bottom:10px;
        color:#999;
    }
    .comment-movie a{
        font-weight:800;
        color:#555;
        text-decoration: none;
    }
    .comment-movie a:hover{
        color:#ff7400;
    }
    .comment-content{
        padding-left:10px;
        margin-bottom:10px;
    }
    .comment-time{
        color:#999;
        font-size:14px;
        text-align: right;
        padding-right:10px;
    }
    .comment-time a{
        margin-right:5px;
        color:#999;
        text-decoration: none;
    }
    .comment-time a:hover{
        color:#ff2b78;
    }
.hot-forum {
  /* float:right; */
  background: #fff;
  width: 320px;
  /* height: 750px; */
  padding: 25px 25px 10px 25px;
}
.hot-forum ul {
  color: #4a4b4d;
  list-style: none;
}
.hot-forum ul li {
  height: 60px;
  margin-bottom: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid #ddd;
}
.hot-forum ul li:nth-child(5) {
  border-bottom: none;
}
.hot-forum ul li a {
  text-decoration: none;
  color: #3c3c3b;
  transition: 0.25s;
}
.hot-forum ul li a:hover {
  color: #ff7400;
  transition: 0.25s;
}
    </style>



// WEBPACK FOOTER //
// src/components/index/user.vue